
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, watch, reactive, onMounted, defineComponent} from 'vue';
import Breadcrumb from "../../components/breadcrumb/Breadcrumb.vue";
import TicketConfigurations from "../../components/configurations/TicketConfigurations.vue";
import {useTicketStore} from '../../stores/TicketStore';
import {storeToRefs} from 'pinia'
import LoadingSpinner from "../../components/loading/LoadingSpinner.vue";
import {PricingStruct } from "../../utils/structs";
import {addParamsToUrl, assertData, fetcher, areEqualArrays, throwAlertMessage, convertInCurrency} from "../../utils/utils";
import {getSkiTicketBaseConfig} from "../../utils/config-helper";
import Select from "../../components/form-elements/Select.vue";

export default defineComponent({
    name: 'ServiceView',
    components: {
        Breadcrumb,
        TicketConfigurations,
        Select,
        LoadingSpinner
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        ticketId: {
            type: String,
            required: true,
        },
        stepViews: {
            type: Array,
            required: true
        },
        isPriceCalculator: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props) {
        const ticketStore = useTicketStore();
        const {
            step,
            selectedDateStart,
            selectedDateEnd,
            selectedOption,
            selectedInsurance,
            selectedUpgrades,
            selectedPriceGroup,
            selectedCurrency,
            selectedPriceConfiguration,
            allPriceGroups,
            allOptions,
            allUpgrades,
            allInsurances,
            ticketConfigurations
        } = storeToRefs(ticketStore);

        const {changeStep, changeOption, changeInsurance, changeUpgrades, changePriceGroup, changePriceConfiguration, changeAllPriceGroups, changeAllInsurances, changeTicketConfigurations,
        changeAllOptions, changeAllUpgrades, changeFinalPrice} = ticketStore;
        const priceGroups = ref<object>([]);
        const priceConfigurations = ref<object>([]);
        const price = ref<number>(0);
        const priceString = ref<String>(null);
        const isMobile = matchMedia('(max-width: 767px)').matches;

        const onChangeStep = (step: number) => {
            changeStep(step);
        }

        const onChangeOption = (option: string) => {
            changeOption(option);
        }

        const onChangeInsurance = (insurance: string) => {
            changeInsurance(insurance);
        }

        const onChangeUpgrades = (upgrades: string[]) => {
            changeUpgrades(upgrades);
        }

        const onChangePriceGroup = (priceGroup: string) => {
            changePriceGroup(priceGroup);
        }

        const onChangeAllOptions = (options: String[]) => {
            changeAllOptions(options);
        }

        const onChangeAllInsurances = (insurances: String[]) => {
            changeAllInsurances(insurances);
        }

        const onChangeAllUpgrades = (upgrades: String[]) => {
            changeAllUpgrades(upgrades);
        }

        const onChangePriceConfiguration = (priceConfiguration: string) => {
            changePriceConfiguration(priceConfiguration);
        }

        const onChangeAllPriceGroups = (priceGroups: object[]) => {
            changeAllPriceGroups(priceGroups);
        }

        const onChangeTicketConfigurations = (ticketConfigurations: object[]) => {
            changeTicketConfigurations(ticketConfigurations);
        }

        const onChangePrice = (price: number) => {
            priceString.value = convertInCurrency(price, selectedCurrency.value);
        }

        const getOption = (id: string) => {
            let option = allOptions.value.filter((option: any) => {
                return option.id === id;
            })[0];

            return option;
        }

        const getInsurance = (id: string) => {
            let insurance = allInsurances.value.filter((insurance: any) => {
                return insurance.id === id;
            })[0];

            return insurance;
        }

        const getUpgrade = (id: string) => {
            let upgrade = allUpgrades.value.filter((upgrade: any) => {
                return upgrade.id === id;
            })[0];

            return upgrade;
        }



        return {
            step,
            selectedDateStart,
            selectedDateEnd,
            selectedOption,
            selectedInsurance,
            selectedUpgrades,
            changeStep,
            changeOption,
            changeInsurance,
            changeUpgrades,
            onChangeOption,
            onChangeInsurance,
            onChangeUpgrades,
            onChangeStep,
            priceGroups,
            priceConfigurations,
            selectedPriceGroup,
            onChangePriceGroup,
            selectedPriceConfiguration,
            price,
            isMobile,
            priceString,
            onChangeAllOptions,
            onChangeAllInsurances,
            onChangeAllUpgrades,
            getOption,
            getUpgrade,
            getInsurance,
            selectedCurrency,
            onChangeAllPriceGroups,
            onChangePriceConfiguration,
            onChangeTicketConfigurations,
            ticketConfigurations,
            allPriceGroups,
            onChangePrice,
            allOptions,
            allInsurances,
            allUpgrades,
            translate
        };
    }
});
